import { useDispatch, useSelector } from "react-redux";
import { Users } from "lucide-react";
import { Select } from "antd";
import { updateField } from "../../../redux/slices/employee-slice";

const RELATIONSHIP_OPTIONS = [
  { value: "wife", label: "Wife" },
  { value: "husband", label: "Husband" }, 
  { value: "father", label: "Father" },
  { value: "mother", label: "Mother" },
  { value: "brother", label: "Brother" },
  { value: "sister", label: "Sister" },
  { value: "child", label: "Child" },
  { value: "uncle", label: "Uncle" },
];

const Dependant = () => {
  const dispatch = useDispatch();
  const form = useSelector((state) => state.employeeForm);

  const handleChange = (e) => {
    const { name, value, type, checked } = e.target;

    dispatch(
      updateField({ name, value: type === "checkbox" ? checked : value })
    );
  };

  const handleSelectChange = (value, name) => {
    dispatch(updateField({ name, value }));
  };

  return (
    <div className="flex items-start justify-between bg-white px-4">
      <div className="flex flex-col gap-3 mt-1">
        <Users className="h-7 w-7 text-active-color stroke-1" />
        <h4 className="font-bold text-md">Dependents</h4>
        <p className="text-gray-400 text-md -mt-2 max-w-xs">
          Fill the employee dependent information
        </p>
      </div>
      <div className="bg-form-bg w-lg rounded-md px-4 flex flex-col gap-6 py-8 mt-5">
        <div className="grid grid-cols-12 gap-5">
          <div className="col-span-6 flex flex-col gap-6">
            {/* First Column */}
            <div className="flex flex-col gap-1">
              <label htmlFor="relationship" className="text-md">
                Relationship
                <span className="text-red-500 relative -top-0.5 ml-0.5">*</span>
              </label>
              <Select
                className="w-full"
                options={RELATIONSHIP_OPTIONS}
                value={form.relationship_type}
                onChange={(value) => handleSelectChange(value, "relationship_type")}
                placeholder="Select option"
              />
            </div>

            <div className="flex flex-col gap-1">
              <label htmlFor="emergency_lastName" className="text-md">
                Last Name
                <span className="text-red-500 relative -top-0.5 ml-0.5">*</span>
              </label>
              <input
                type="text"
                className="border px-2 py-1 rounded-md border-secondary text-md outline-none bg-white"
                placeholder="Last Name"
                name="emergency_lastName"
                onChange={handleChange}
                value={form.emergency_lastName}
              />
            </div>
          </div>

          <div className="col-span-6 flex flex-col gap-6">
            <div className="flex flex-col gap-1">
              <label htmlFor="emergency_firstName" className="text-md">
                First Name
                <span className="text-red-500 relative -top-0.5 ml-0.5">*</span>
              </label>
              <input
                type="text"
                className="border px-2 py-1 rounded-md border-secondary text-md outline-none bg-white"
                placeholder="First Name"
                name="emergency_firstName"
                onChange={handleChange}
                value={form.emergency_firstName}
              />
            </div>
            
            <div className="flex flex-col gap-1">
              <label htmlFor="emergency_contact" className="text-md">
                Contact No
              </label>
              <input
                type="text"
                className="border px-2 py-1 rounded-md border-secondary text-md outline-none bg-white"
                placeholder="Contact No"
                name="emergency_contact"
                onChange={handleChange}
                value={form.emergency_contact}
              />
            </div>
          </div>
        </div>
        <div className="flex flex-col gap-1 col-span-12">
          <label htmlFor="remarks" className="text-md">
            Remarks
          </label>
          <textarea
            className="border px-2 py-1 rounded-md border-secondary text-md outline-none bg-white"
            rows="3"
            placeholder="Enter any remarks..."
            name="remarks"
            onChange={handleChange}
            value={form.remarks}
          ></textarea>
        </div>
      </div>
    </div>
  );
};

export default Dependant;
